import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import './EmptyState.css';

const EmptyState = ({
    icon = 'inbox',
    title,
    message,
    actionButton,
    className = ''
}) => {
    return (
        <div className={`empty-state ${className}`}>
            <div className="empty-state-content">
                <i className={`bi bi-${icon} empty-state-icon`}></i>
                {title && <h3 className="empty-state-title">{title}</h3>}
                {message && <p className="empty-state-message">{message}</p>}
                {actionButton && (
                    <Button
                        variant={actionButton.variant || 'danger'}
                        onClick={actionButton.onClick}
                        className="empty-state-action"
                    >
                        {actionButton.icon && <i className={`bi bi-${actionButton.icon} me-2`}></i>}
                        {actionButton.label}
                    </Button>
                )}
            </div>
        </div>
    );
};

EmptyState.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    actionButton: PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.string,
        variant: PropTypes.string,
        onClick: PropTypes.func.isRequired
    }),
    className: PropTypes.string
};

export default EmptyState;